// removed by extract-text-webpack-plugin
module.exports = {"leftSection-wrapper":"index__leftSection-wrapper___2pJPU","right-section-wrapper":"index__right-section-wrapper___2o0Er"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard/index.less
// module id = 1306
// module chunks = 3